import { AdminFetchFeeWithdrawalReport, AdminFetchFeeWithdrawals } from 'src/constants/actionTypes'
import type {
  FeeWithdrawalsPage,
  FetchFeeWithdrawalReportPayload,
} from 'src/interfaces/feeWithdrawal'
import { resolveErrorMessage } from 'src/utils/sagaErrorMessage'
import { Action } from 'src/utils/reduxUtils'
import type { FeeWithdrawalsState } from './types'

const getInitialState = (): FeeWithdrawalsState => {
  return {
    withdrawals: [],
    pagination: {},
    loading: false,
    error: null,
    reportLoadingIds: {},
  }
}

export const feeWithdrawalsReducer = (
  state: FeeWithdrawalsState = getInitialState(),
  action: Action<unknown>,
): FeeWithdrawalsState => {
  switch (action.type) {
    case AdminFetchFeeWithdrawals.type.REQUEST:
      return { ...state, loading: true, error: null }
    case AdminFetchFeeWithdrawals.type.SUCCESS: {
      const page = action.payload as FeeWithdrawalsPage | undefined

      return {
        ...state,
        withdrawals: page?.data ?? [],
        pagination: page?.pagination ?? {},
        loading: false,
        error: null,
      }
    }
    // The rows are dropped so the inline error and Retry are not shown over a stale page.
    case AdminFetchFeeWithdrawals.type.FAILED:
      return {
        ...state,
        withdrawals: [],
        pagination: {},
        loading: false,
        error: resolveErrorMessage(action.payload, 'Failed to load fee withdrawals'),
      }

    case AdminFetchFeeWithdrawalReport.type.REQUEST: {
      const feeWithdrawalId = (action.payload as FetchFeeWithdrawalReportPayload | undefined)
        ?.feeWithdrawalId

      if (!feeWithdrawalId) {
        return state
      }

      return {
        ...state,
        reportLoadingIds: { ...state.reportLoadingIds, [feeWithdrawalId]: true },
      }
    }
    // Both payloads carry `feeWithdrawalId` (`.failed` wraps the error with it).
    case AdminFetchFeeWithdrawalReport.type.SUCCESS:
    case AdminFetchFeeWithdrawalReport.type.FAILED: {
      const feeWithdrawalId = (action.payload as FetchFeeWithdrawalReportPayload | undefined)
        ?.feeWithdrawalId

      if (!feeWithdrawalId || !state.reportLoadingIds[feeWithdrawalId]) {
        return state
      }

      const reportLoadingIds = { ...state.reportLoadingIds }

      delete reportLoadingIds[feeWithdrawalId]

      return { ...state, reportLoadingIds }
    }

    default:
      return state
  }
}
